import React, { FC, useState } from 'react';
import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import { ArrowDownIcon, ArrowUpIcon, PlusIcon } from '../../../svgs/consulting-business-services';

interface ProjectsTextArrayProps {
  title: string;
  description: string;
  listServices: Array<{ title: string; description: string; detail: string }>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      margin: theme.spacing(7, 0, 0),
    },
    title: {
      fontWeight: 700,
      fontSize: 32,
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(4),
      [theme.breakpoints.up('md')]: {
        fontSize: 54,
      },
    },
    text: {
      fontSize: 16,
      maxWidth: 1000,
      marginBottom: theme.spacing(15),
      color: `#453737`,
      [theme.breakpoints.up('md')]: {
        fontSize: 24,
      },
    },
    serviceTitle: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 15,
      color: `#453737`,
    },
    serviceText: {
      fontSize: 16,
      marginBottom: 51,
      color: `#453737`,
      [theme.breakpoints.up('md')]: {
        fontSize: 24,
      },
    },
    serviceDetail: {
      marginTop: 15,
      fontSize: 16,
      color: `#453737`,
      marginBottom: theme.spacing(10),
      [theme.breakpoints.up('md')]: {
        fontSize: 24,
      },
    },
    divider: {
      width: '100%',
      height: 1,
      backgroundColor: `#453737`,
      marginBottom: theme.spacing(10),
    },
    openedButton: {
      backgroundColor: theme.palette.primary.main,
      marginBottom: theme.spacing(3),
      minHeight: 220,
      maxWidth: 60,
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        maxWidth: 85,
      },
    },
    button: {
      backgroundColor: theme.palette.common.white,
      marginBottom: theme.spacing(15),
      border: `3px solid ${theme.palette.primary.main}`,
      minHeight: 220,
      maxWidth: 60,
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        maxWidth: 85,
      },
    },
    icon: {
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transition: 'transform 0.3s ease',
    },
    rotated: {
      transform: 'rotate(45deg)',
    },
  });
});

const NavigateComplex: FC<ProjectsTextArrayProps> = ({ title, description, listServices }) => {
  const classes = useStyles();
  const [openService, setOpenService] = useState<string | null>(null);

  const handleServiceClick = (serviceTitle: string) => {
    setOpenService(openService === serviceTitle ? null : serviceTitle);
  };

  return (
    <Box className={classes.root}>
      <Container fixed>
        <Typography className={classes.title} data-aos="fade-up" data-aos-duration="1500">
          {title}
        </Typography>
        <Typography className={classes.text} data-aos="fade-up" data-aos-duration="1500">
          {description}
        </Typography>
        {listServices.map((service) => (
          <Grid key={service.title} container justify={'space-between'} spacing={2}>
            <Grid item lg={11} xs={10}>
              <Typography className={classes.serviceTitle}>{service.title}</Typography>
              <Typography className={classes.serviceText}>{service.description}</Typography>
            </Grid>
            <Grid
              onClick={() => handleServiceClick(service.title)}
              className={openService === service.title ? classes.openedButton : classes.button}
              item
              lg={1}
              xs={2}
            >
              {openService === service.title ? <ArrowUpIcon /> : <ArrowDownIcon />}
            </Grid>

            {openService === service.title && (
              <>
                <Grid key={service.title} container spacing={2}>
                  <Grid item md={11} xs={10}>
                    <Typography className={classes.serviceTitle}>Service Detail</Typography>
                  </Grid>
                </Grid>
                <Typography className={classes.serviceDetail}>{service.detail}</Typography>
                <Box className={classes.divider} />
              </>
            )}
          </Grid>
        ))}
      </Container>
    </Box>
  );
};

export default NavigateComplex;
